import { ODEME_DURUMLARI, TAHKIM_ASAMALARI } from "./tahkimApi";

/** Hedef aşamaya geçerken istenen bilgiler (zorunlu değil, önerilir). */
export const ASAMA_GECIS_ALANLARI = {
    ON_TAHKIM: [],
    BASVURU: [
        { key: "basvuru_no", label: "Başvuru No", type: "text", placeholder: "STK başvuru numarası" },
        { key: "basvuru_tarihi", label: "Başvuru Tarihi", type: "date" },
        { key: "basvuru_sahibi", label: "Başvuru Sahibi", type: "text" },
        { key: "sigorta_sirketi", label: "Sigorta Şirketi", type: "text" },
    ],
    HAKEM: [
        { key: "hakem", label: "Hakem Ad Soyad", type: "text" },
        { key: "hakem_email", label: "Hakem E-posta", type: "email" },
        { key: "hakem_atama_tarihi", label: "Hakem Atama Tarihi", type: "date" },
    ],
    BILIRKISI: [
        { key: "bilirkisi_adi", label: "Bilirkişi Ad Soyad", type: "text" },
        { key: "bilirkişi_ucreti", label: "Bilirkişi Ücreti (TL)", type: "number", step: "0.01" },
    ],
    ARA_KARAR: [
        { key: "karar_linki", label: "Ara Karar Linki", type: "url", placeholder: "https://…" },
        { key: "dogrulama_kodu", label: "Doğrulama Kodu", type: "text" },
    ],
    KARAR: [
        { key: "karar_tarihi", label: "Karar Tarihi", type: "date" },
        { key: "karar_linki", label: "Karar Linki", type: "url" },
        { key: "dogrulama_kodu", label: "Doğrulama Kodu", type: "text" },
    ],
    ODEME: [
        { key: "son_odeme_tarihi", label: "Son Ödeme Tarihi", type: "date" },
        { key: "iban", label: "IBAN", type: "text" },
        { key: "odeme_tutari", label: "Ödeme Tutarı (TL)", type: "number", step: "0.01" },
        {
            key: "odeme_durumu",
            label: "Ödeme Durumu",
            type: "select",
            options: ODEME_DURUMLARI,
        },
    ],
    KAPANDI: [
        { key: "kapanis_evrak_tamam", label: "Kapanış evrak tamam", type: "checkbox" },
        { key: "kapanis_odeme_onay", label: "Kapanış ödeme onay", type: "checkbox" },
    ],
};

/** Tahkim Veri Girişi entity alanları — aşamaya göre gruplu. */
export const VERI_GIRISI_GRUPLARI = [
    { asama: "BASVURU", label: "Başvuru bilgileri", icon: "file" },
    { asama: "HAKEM", label: "Hakem bilgileri", icon: "scale" },
    { asama: "BILIRKISI", label: "Bilirkişi", icon: "user" },
    { asama: "ARA_KARAR", label: "Ara karar", icon: "link" },
    { asama: "KARAR", label: "Karar", icon: "gavel" },
    { asama: "ODEME", label: "Ödeme takibi", icon: "wallet" },
].map((g) => ({
    ...g,
    fields: ASAMA_GECIS_ALANLARI[g.asama] || [],
}));

export const ASAMA_STIL = {
    ON_TAHKIM: {
        step: 1,
        border: "border-sky-500/45",
        header: "from-sky-600/25 via-sky-500/10 to-transparent",
        accent: "text-sky-300",
        dot: "bg-sky-500",
        ring: "ring-sky-500/40",
        cardBorder: "border-l-sky-500",
    },
    BASVURU: {
        step: 2,
        border: "border-cyan-500/45",
        header: "from-cyan-600/25 via-cyan-500/10 to-transparent",
        accent: "text-cyan-300",
        dot: "bg-cyan-500",
        ring: "ring-cyan-500/40",
        cardBorder: "border-l-cyan-500",
    },
    HAKEM: {
        step: 3,
        border: "border-violet-500/45",
        header: "from-violet-600/25 via-violet-500/10 to-transparent",
        accent: "text-violet-300",
        dot: "bg-violet-500",
        ring: "ring-violet-500/40",
        cardBorder: "border-l-violet-500",
    },
    BILIRKISI: {
        step: 4,
        border: "border-amber-500/45",
        header: "from-amber-600/25 via-amber-500/10 to-transparent",
        accent: "text-amber-300",
        dot: "bg-amber-500",
        ring: "ring-amber-500/40",
        cardBorder: "border-l-amber-500",
    },
    ARA_KARAR: {
        step: 5,
        border: "border-emerald-500/45",
        header: "from-emerald-600/25 via-emerald-500/10 to-transparent",
        accent: "text-emerald-300",
        dot: "bg-emerald-500",
        ring: "ring-emerald-500/40",
        cardBorder: "border-l-emerald-500",
    },
    KARAR: {
        step: 6,
        border: "border-[#D4AF37]/45",
        header: "from-[#D4AF37]/25 via-[#D4AF37]/10 to-transparent",
        accent: "text-[#F3E5AB]",
        dot: "bg-[#D4AF37]",
        ring: "ring-[#D4AF37]/40",
        cardBorder: "border-l-[#D4AF37]",
    },
    ODEME: {
        step: 7,
        border: "border-orange-500/45",
        header: "from-orange-600/25 via-orange-500/10 to-transparent",
        accent: "text-orange-300",
        dot: "bg-orange-500",
        ring: "ring-orange-500/40",
        cardBorder: "border-l-orange-500",
    },
    KAPANDI: {
        step: 8,
        border: "border-slate-500/45",
        header: "from-slate-600/25 via-slate-500/10 to-transparent",
        accent: "text-slate-400",
        dot: "bg-slate-500",
        ring: "ring-slate-500/40",
        cardBorder: "border-l-slate-500",
    },
};

export const BASVURU_SONRASI_ASAMALAR = TAHKIM_ASAMALARI.filter(
    (a) => !["ON_TAHKIM", "KAPANDI"].includes(a.value),
);

export const PIPELINE_ASAMALAR = TAHKIM_ASAMALARI.filter((a) => a.value !== "KAPANDI");

export function asamaLabel(value) {
    return TAHKIM_ASAMALARI.find((a) => a.value === value)?.label || value;
}

export function asamaIndex(value) {
    return TAHKIM_ASAMALARI.findIndex((a) => a.value === value);
}

export function sonrakiAsama(mevcut) {
    const idx = asamaIndex(mevcut);
    if (idx < 0 || idx >= TAHKIM_ASAMALARI.length - 1) return null;
    return TAHKIM_ASAMALARI[idx + 1].value;
}

export function gecisAlanlari(hedefAsama) {
    return ASAMA_GECIS_ALANLARI[hedefAsama] || [];
}

/** Modal: hedef aşamaya kadar tüm veri girişi grupları. */
export function veriGirisiGruplari(hedefAsama) {
    const hedefIdx = asamaIndex(hedefAsama);
    if (hedefIdx < 0) return [];
    return VERI_GIRISI_GRUPLARI.filter((g) => asamaIndex(g.asama) <= hedefIdx);
}

export function tumGecisAlanlari(hedefAsama) {
    const seen = new Set();
    const out = [];
    veriGirisiGruplari(hedefAsama).forEach((g) => {
        g.fields.forEach((f) => {
            if (!seen.has(f.key)) {
                seen.add(f.key);
                out.push(f);
            }
        });
    });
    return out;
}

export function bosOnerilenAlanlar(hedefAsama, form, mevcutKayit = {}) {
    const alanlar = tumGecisAlanlari(hedefAsama).filter((a) => a.type !== "checkbox");
    return alanlar.filter((a) => {
        const v = form[a.key] ?? mevcutKayit[a.key];
        return v == null || String(v).trim() === "";
    });
}

export function kartVeriOzet(item) {
    const parca = [];
    if (item.basvuru_no) parca.push({ key: "basvuru", text: item.basvuru_no });
    if (item.hakem) parca.push({ key: "hakem", text: item.hakem });
    if (item.bilirkisi_adi) parca.push({ key: "bilirkisi", text: item.bilirkisi_adi });
    if (item.son_odeme_tarihi) parca.push({ key: "odeme", text: item.son_odeme_tarihi });
    return parca;
}

export function kartEksikUyari(item) {
    const u = [];
    if (item.tahkim_asamasi === "BASVURU" && !item.basvuru_no) u.push("Başvuru no");
    if (["BASVURU", "HAKEM"].includes(item.tahkim_asamasi) && !item.hakem) u.push("Hakem");
    if (item.tahkim_asamasi === "BILIRKISI" && !item.bilirkisi_adi) u.push("Bilirkişi");
    if (item.son_odeme_gecikme) u.push("Ödeme gecikmiş");
    return u;
}

export function findKanbanItem(columns, id) {
    for (const col of columns || []) {
        const item = (col.items || []).find((i) => String(i.id) === String(id));
        if (item) return item;
    }
    return null;
}
